let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("9zLwF"), load("g4i5b")]).then(() => parcelRequire('9bkHc'));